/**
 * Detects if the current device is Android (phone or tablet).
 * @returns true if Android, false otherwise
 */
export function isAndroid(): boolean {
  return /android/i.test(navigator.userAgent);
}
